import { useLazyQuery, useMutation } from "@apollo/client";
import prepareComponent from "@bluframe/grapple/prepareComponent";
import { mutations, queries } from "@bluframe/mightychroma-mightytool-graphql-schema";
import useUser from "hooks/useUser";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import Add from "./Add";
const { vendors: { GET_LABELS, SEARCH_VENDORS } } = queries;
const { vendors: { ADD_LABEL } } = mutations;
const usePrepareComponent = () => {
    const history = useHistory();
    const [selectedVendorId, setSelectedVendorId] = useState();
    const { isAdmin, isEditor } = useUser();
    const [addLabel, { loading: addLabelLoading }] = useMutation(ADD_LABEL, { refetchQueries: [GET_LABELS] });
    const [searchVendors, { data: searchVendorsData, loading: searchVendorsLoading }] = useLazyQuery(SEARCH_VENDORS);
    const onCancel = () => history.push("/vendors/labels");
    const onSelectVendorId = (id) => {
        setSelectedVendorId(id);
    };
    const onGetVendorsSuggestions = ({ inputValue }) => {
        searchVendors({
            variables: {
                searchVendorsInput: {
                    name: inputValue
                }
            }
        });
    };
    const onSave = (itemUpdate) => {
        if (!itemUpdate.vendorId || !itemUpdate.status) {
            return;
        }
        const itemAdd = {
            ...itemUpdate,
            isPublished: false,
            status: itemUpdate.status,
            vendorId: itemUpdate.vendorId
        };
        addLabel({
            onCompleted: ({ addLabel: { id } }) => {
                history.push(`/vendors/labels/${id}`);
            },
            variables: { labelAddInput: itemAdd }
        });
    };
    return {
        isAdmin,
        isEditor,
        isSaveLoading: addLabelLoading,
        isVendorsSuggestionsLoading: searchVendorsLoading,
        onCancel,
        onGetVendorsSuggestions,
        onSave,
        onSelectVendorId,
        selectedVendorId,
        vendors: searchVendorsData?.searchVendors ?? []
    };
};
export default prepareComponent(usePrepareComponent)(Add);
